import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Edit({ attributes={
  color: "",
  classes: "",
  size: "24"
}, clickHandler }) {
  const navigate = useNavigate();

  return (
    <div className={attributes.classes} onClick={clickHandler}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={attributes.size}
        height={attributes.size}
        viewBox="0 0 38 38"
      >
        <g
          id="Group_16163"
          data-name="Group 16163"
          transform="translate(-1170 -261)"
        >
          <circle
            id="Ellipse_134"
            data-name="Ellipse 134"
            cx="19"
            cy="19"
            r="19"
            transform="translate(1170 261)"
            fill={attributes.color}
          />
          <g
            id="Icon_akar-pencil"
            data-name="Icon akar-pencil"
            transform="translate(1178.2 269.551)"
          >
            <path
              id="Path_11572"
              data-name="Path 11572"
              d="M5.464,14.017l8.853-8.854a1.852,1.852,0,0,1,2.619,2.618L8.082,16.636a1.447,1.447,0,0,1-.739.4L4.5,17.6l.569-2.843a1.447,1.447,0,0,1,.4-.739Z"
              transform="translate(0 0)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_11573"
              data-name="Path 11573"
              d="M21.75,9.75l2.17,2.17"
              transform="translate(-8.93 -2.641)"
              fill="none"
              stroke="#fff"
              strokeWidth="1"
            />
          </g>
        </g>
      </svg>
    </div>
  );
}

export default Edit;